/* src/app/components/page-header/page-header.component.scss */
.sidemenu {
  width: 100%;
  min-height: 68px;
  display: flex;
  align-items: center;
  padding: 12px 24px;
  background: transparent;
  border: 0;
  position: relative;
  z-index: 10;
  box-sizing: border-box;
}
.header-content {
  width: 100%;
  min-width: 0;
}
.page-header-contents {
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
}
.mobile-menu {
  display: none;
  flex: 0 0 auto;
  margin-right: 12px;
}
.menu-toggle {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.72);
  color: #344054;
  font-size: 16px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.menu-toggle:hover {
  background: #ffffff;
  border-color: #d0d5dd;
  color: #253b80;
  box-shadow: 0 3px 10px rgba(16, 24, 40, 0.08);
}
.menu-toggle:active {
  transform: scale(0.96);
}
.menu-toggle:focus-visible {
  outline: none;
  border-color: #635bff;
  box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.14);
}
:host ::ng-deep .page-title,
:host ::ng-deep .page-heading {
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}
:host ::ng-deep .page-title h3 {
  min-width: 0;
  margin: 0;
  color: #101828;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep .page-heading {
  gap: 12px;
}
:host ::ng-deep .page-heading .page-heading-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e7ff;
  border-radius: 11px;
  background:
    linear-gradient(
      135deg,
      #f1f3ff 0%,
      #e9ebff 100%);
  color: #253b80;
  font-size: 16px;
  box-shadow: 0 3px 10px rgba(37, 59, 128, 0.06);
}
:host ::ng-deep .page-heading > div {
  min-width: 0;
  overflow: hidden;
}
:host ::ng-deep .page-heading h3 {
  min-width: 0;
  margin: 0;
  color: #101828;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep .page-heading p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 992px) {
  .sidemenu {
    min-height: 64px;
    padding: 10px 20px;
  }
  .mobile-menu {
    display: flex;
    align-items: center;
  }
  :host ::ng-deep .page-title h3 {
    font-size: 20px;
  }
  :host ::ng-deep .page-heading h3 {
    font-size: 19px;
  }
}
@media (max-width: 768px) {
  .sidemenu {
    min-height: 60px;
    padding: 9px 16px;
  }
  .page-header-contents {
    width: 100%;
  }
  .mobile-menu {
    margin-right: 10px;
  }
  .menu-toggle {
    width: 40px;
    height: 40px;
    border-radius: 9px;
    font-size: 15px;
  }
  :host ::ng-deep .page-heading {
    gap: 9px;
  }
  :host ::ng-deep .page-heading-icon {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    border-radius: 9px;
    font-size: 14px;
  }
  :host ::ng-deep .page-title h3 {
    font-size: 19px;
    line-height: 1.25;
  }
  :host ::ng-deep .page-heading h3 {
    font-size: 18px;
    line-height: 1.25;
  }
  :host ::ng-deep .page-heading p {
    margin-top: 2px;
    font-size: 11px;
    line-height: 1.35;
  }
}
@media (max-width: 576px) {
  .sidemenu {
    min-height: 58px;
    padding: 8px 14px;
  }
  .mobile-menu {
    margin-right: 9px;
  }
  .menu-toggle {
    width: 40px;
    height: 40px;
    border-radius: 9px;
  }
  :host ::ng-deep .page-title h3 {
    font-size: 18px;
  }
  :host ::ng-deep .page-heading {
    gap: 8px;
  }
  :host ::ng-deep .page-heading h3 {
    font-size: 17px;
  }
  :host ::ng-deep .page-heading p {
    font-size: 11px;
  }
  :host ::ng-deep .page-heading-icon {
    width: 35px;
    height: 35px;
    flex-basis: 35px;
    border-radius: 9px;
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .sidemenu {
    min-height: 56px;
    padding: 8px 12px;
  }
  .mobile-menu {
    margin-right: 8px;
  }
  .menu-toggle {
    width: 38px;
    height: 38px;
    font-size: 14px;
  }
  :host ::ng-deep .page-title h3,
  :host ::ng-deep .page-heading h3 {
    font-size: 17px;
  }
  :host ::ng-deep .page-heading {
    gap: 8px;
  }
  :host ::ng-deep .page-heading-icon {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }
  :host ::ng-deep .page-heading p {
    max-width: 100%;
    font-size: 10.5px;
  }
}
@media (max-width: 360px) {
  .sidemenu {
    min-height: 54px;
    padding: 7px 10px;
  }
  .mobile-menu {
    margin-right: 7px;
  }
  .menu-toggle {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    font-size: 13px;
  }
  :host ::ng-deep .page-heading {
    gap: 7px;
  }
  :host ::ng-deep .page-heading-icon {
    display: none !important;
  }
  :host ::ng-deep .page-title h3,
  :host ::ng-deep .page-heading h3 {
    font-size: 16px;
  }
  :host ::ng-deep .page-heading p {
    font-size: 10px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .menu-toggle {
    transition: none;
  }
}
/*# sourceMappingURL=page-header.component.css.map */
